import { useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import vi from 'date-fns/locale/vi';
import { Table, Typography } from 'antd';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

import './table.scss';
import { homeGrid, dataHomeGrid } from '~/data/dummy';
import { useStateContext } from '~/contexts/ContextProvider';

const { Text } = Typography;
registerLocale('vi', vi);

const getDate = (type) => {
  let beginDate = new Date();
  let endDate = new Date();

  if (type === 'preDay') {
    beginDate.setDate(beginDate.getDate() - 2);
    endDate.setDate(endDate.getDate() - 1);
  }
  if (type === 'today') {
    endDate.setDate(endDate.getDate() + 1);
  }
  if (type === 'thisWeek') {
    beginDate.setDate(beginDate.getDate() - beginDate.getDay() + 1);
    endDate.setDate(endDate.getDate() + 7 - endDate.getDay());
  }
  if (type === 'preWeek') {
    beginDate.setDate(beginDate.getDate() - beginDate.getDay() - 6);
    endDate.setDate(endDate.getDate() - endDate.getDay());
  }
  if (type === 'thisMonth') {
    beginDate = new Date(beginDate.getFullYear(), beginDate.getMonth(), 1);
    endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
  }
  if (type === 'preMonth') {
    beginDate = new Date(beginDate.getFullYear(), beginDate.getMonth() - 1, 1);
    endDate = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
  }
  if (type === 'pre7Day') {
    beginDate.setDate(beginDate.getDate() - 7);
  }
  if (type === 'pre30Day') {
    beginDate.setDate(beginDate.getDate() - 30);
  }
  return { beginDate, endDate };
};

const Home = () => {
  const { formatMoney } = useStateContext();

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [buttonActiveTab, setButtonActiveTab] = useState('today');
  const handleDateForm = (type) => {
    setStartDate(getDate(type).beginDate);
    setEndDate(getDate(type).endDate);
    setButtonActiveTab(type);
  };

  return (
    <div className="">
      <div className="border-b w-full flex flex-col items-center">
        <span className="text-[11px] w-full">
          Tìm kiếm theo thời gian{' '}
          <span className="text-red-500">* Kiếm tra báo cáo đại lý 60 ngày gần đây</span>
        </span>
        <div className="flex w-full items-center">
          <DatePicker
            className="p-2 rounded-sm border w-[150px] text-sm"
            selected={startDate}
            dateFormat="yyyy/MM/dd"
            locale="vi"
            onChange={(date) => {
              setStartDate(date);
            }}
          />
          <span className="ml-2"></span>
          <DatePicker
            className="p-2 rounded-sm border w-[150px] text-sm"
            selected={endDate}
            dateFormat="yyyy/MM/dd"
            locale="vi"
            onChange={(date) => {
              setEndDate(date);
            }}
          />
          <button
            onClick={() => handleDateForm('preDay')}
            className="bg-[#f9f9f9] rounded-md text-lg w-full p-1 mx-2"
            style={{
              backgroundColor: buttonActiveTab === 'preDay' ? '#6f9edc' : '#f9f9f9',
              color: buttonActiveTab === 'preDay' ? '#fff' : 'black',
            }}>
            Hôm qua
          </button>
          <button
            onClick={() => handleDateForm('today')}
            style={{
              backgroundColor: buttonActiveTab === 'today' ? '#6f9edc' : '#f9f9f9',
              color: buttonActiveTab === 'today' ? '#fff' : 'black',
            }}
            className="bg-[#f9f9f9] rounded-md text-lg w-full p-1 mx-2">
            Hôm nay
          </button>
          <button
            onClick={() => handleDateForm('thisWeek')}
            className="bg-[#f9f9f9] rounded-md text-lg w-full p-1 mx-2"
            style={{
              backgroundColor: buttonActiveTab === 'thisWeek' ? '#6f9edc' : '#f9f9f9',
              color: buttonActiveTab === 'thisWeek' ? '#fff' : 'black',
            }}>
            Tuần này
          </button>
          <button
            onClick={() => handleDateForm('preWeek')}
            className="bg-[#f9f9f9] rounded-md text-lg w-full p-1 mx-2"
            style={{
              backgroundColor: buttonActiveTab === 'preWeek' ? '#6f9edc' : '#f9f9f9',
              color: buttonActiveTab === 'preWeek' ? '#fff' : 'black',
            }}>
            Tuần trước
          </button>
          <button
            onClick={() => handleDateForm('thisMonth')}
            className="bg-[#f9f9f9] rounded-md text-lg w-full p-1 mx-2"
            style={{
              backgroundColor: buttonActiveTab === 'thisMonth' ? '#6f9edc' : '#f9f9f9',
              color: buttonActiveTab === 'thisMonth' ? '#fff' : 'black',
            }}>
            Tháng này
          </button>
          <button
            onClick={() => handleDateForm('preMonth')}
            className="bg-[#f9f9f9] rounded-md text-lg w-full p-1 mx-2"
            style={{
              backgroundColor: buttonActiveTab === 'preMonth' ? '#6f9edc' : '#f9f9f9',
              color: buttonActiveTab === 'preMonth' ? '#fff' : 'black',
            }}>
            Tháng trước
          </button>
          <button
            onClick={() => handleDateForm('pre7Day')}
            className="bg-[#f9f9f9] rounded-md text-sm w-full p-2 mx-2"
            style={{
              backgroundColor: buttonActiveTab === 'pre7Day' ? '#6f9edc' : '#f9f9f9',
              color: buttonActiveTab === 'pre7Day' ? '#fff' : 'black',
            }}>
            7 ngày trước
          </button>
          <button
            onClick={() => handleDateForm('pre30Day')}
            className="bg-[#f9f9f9] rounded-md text-sm w-full p-2 mx-2"
            style={{
              backgroundColor: buttonActiveTab === 'pre30Day' ? '#6f9edc' : '#f9f9f9',
              color: buttonActiveTab === 'pre30Day' ? '#fff' : 'black',
            }}>
            30 ngày trước
          </button>
        </div>
        <div className="mt-10 w-full flex">
          <div className=" flex flex-col w-[300px]">
            <label htmlFor="utc">Múi giờ</label>
            <select
              name=""
              id="utc"
              className="border rounded-sm px-2 py-1 mt-2 focus:outline-none">
              <option value="+7">UTC+7:00</option>
            </select>
          </div>
          <div className=" flex flex-col w-[300px] ml-4">
            <label htmlFor="type">Loại tìm kiếm</label>
            <select
              name=""
              id="type"
              className="border rounded-sm px-2 py-1 mt-2 focus:outline-none">
              <option value="id">ID đại lý</option>
            </select>
          </div>
          <div className=" flex flex-col w-[300px] ml-4">
            <label htmlFor="id">ID đại lý</label>
            <input
              type="text"
              id="id"
              placeholder="ID đại lý"
              className="border rounded-sm px-2 py-1 mt-2 focus:outline-none"
            />
          </div>
        </div>

        <button className="flex items-center bg-[#01b1f0] text-white px-3 py-1 rounded-md my-4 justify-self-center">
          <MagnifyingGlassIcon width="18" />
          Tìm kiếm
        </button>
      </div>
      <div className="mt-4">
        <h3 className="text-2xl font-medium">Báo cáo đại lý tuyến trên</h3>
        <span className="text-[red] text-sm">
          (Báo cáo này sẽ hiển thị các đại lý cấp dưới hiện tại và dữ liệu của họ. Nếu cần kết toán
          với đại lý, vui lòng lưu dữ liệu trước khi đổi tuyến đại lý，Hệ thống kết toán lúc
          00:00~01:00(GMT+8). Vui lòng kiểm tra dữ liệu sau khi kết toán)
        </span>
        <Table
          rowKey="id"
          dataSource={dataHomeGrid}
          columns={homeGrid}
          // loading={loading}
          bordered
          pagination={{
            defaultPageSize: 50,
            showSizeChanger: true,
            pageSizeOptions: ['50', '100', '150'],
            showQuickJumper: true,
          }}
          summary={(pageData) => {
            let totalNumber1 = pageData.reduce((pre, current) => {
              return pre + current.totalNumber1;
            }, 0);
            let totalNumber2 = pageData.reduce((pre, current) => {
              return pre + current.totalNumber2;
            }, 0);
            let totalPlayer = pageData.reduce((pre, current) => {
              return pre + current.totalPlayer;
            }, 0);

            let recharge = pageData.reduce((pre, current) => {
              return pre + current.recharge;
            }, 0);
            let withdrawal = pageData.reduce((pre, current) => {
              return pre + current.withdrawal;
            }, 0);
            let handEdit = pageData.reduce((pre, current) => {
              return pre + current.handEdit;
            }, 0);
            let totalBet = pageData.reduce((pre, current) => {
              return pre + current.totalBet;
            }, 0);
            let legitBet = pageData.reduce((pre, current) => {
              return pre + current.legitBet;
            }, 0);
            let win = pageData.reduce((pre, current) => {
              return pre + current.win;
            }, 0);
            let lose = pageData.reduce((pre, current) => {
              return pre + current.lose;
            }, 0);
            return (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell>Tổng</Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{totalNumber1}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{totalNumber2}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{totalPlayer}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{formatMoney(recharge)}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{formatMoney(withdrawal)}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{handEdit}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{formatMoney(totalBet)}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{legitBet}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>
                      {win}/{lose}
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell colSpan={3}></Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
        />
      </div>
    </div>
  );
};

export default Home;
